import React, {useRef, useState} from "react";
import {Link} from "gatsby";
import Hamburger from "hamburger-react";
import {useClickAway, useLocation} from "react-use";
import {AnimatePresence, motion} from "framer-motion";
import styled, {css} from "styled-components";
import colors from "../colors";
import routes from "../../routes";
import LanguageSwitcherDesktop from "../UI/LanguageSwitcher/desktop";
import {injectIntl} from "gatsby-plugin-intl";

import logo from "../../images/svg/champion-logo.svg";

const MobileMenu = ({intl}) => {
  const location = useLocation();

  // Get the current language code
  const currentLanguageCode = intl?.locale;

  const [isOpen, setOpen] = useState(false);
  const refMobileMenu = useRef(null);

  useClickAway(refMobileMenu, () => setOpen(false));

  return (
    <Menu
      ref={refMobileMenu}
      isOpen={isOpen}
    >
      <div className={'mobile-header-top'}>
        <img src={logo} height={50}/>

        <LanguageSwitcherDesktop/>
        <Hamburger
          toggled={isOpen}
          size={20}
          toggle={setOpen}
          color={colors.silverText}
          direction={'right'}
        />
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className={'mobile-menu-list'}
          >
            <ul>
              {routes.map((route, idx) => {
                const isActive = (
                  (idx === 0 && location?.pathname === '/')
                  ||
                  (idx && location?.pathname?.includes(route.href))
                )
                return (
                  <motion.li
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{
                      type: "spring",
                      stiffness: 260,
                      damping: 20,
                      delay: 0.1 + idx / 10,
                    }}
                    key={route.title}
                  >
                    <Link
                      className={isActive ? 'active' : ''}
                      onClick={() => setOpen((prev) => !prev)}
                      to={`/${currentLanguageCode}${route.href}`}
                    >
                      {intl.formatMessage({ id: `menu.${route?.slug}` })}
                    </Link>
                  </motion.li>
                );
              })}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </Menu>
  )
}

export default injectIntl(MobileMenu)

const Menu = styled.div `
  position: absolute;
  z-index: 1;

  ${({ isOpen }) => isOpen && css `
      background-color: var(--color-background);
  `};

  .mobile-header-top {
    width: 100vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 10px;
    
    img {
      padding-left: 15px;
    }
  }

  .mobile-menu-list {
    background-color: var(--color-background);

    ul {
      list-style: none;
      padding: 0;

      li {
        position: relative;
        padding: 25px;

        &:not(:last-child)::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          border-bottom: 1px solid #333;
        }

        a {
          color: var(--color-white);

          font-family: var(--font-gothic);
          font-size: 18px;
          font-weight: 300;

          &.active {
            color: var(--color-silver);
            font-weight: 500;
          }
        }
      }
    }
  }

  @media (min-width: 999px) {
    display: none;
  }
`
